import { createContext, useContext } from "react";
import { useDeprecationWarning } from "@jutro/platform";
export var FooterDeprecationContext = createContext(void 0);
export var useFooterDeprecationMessage = function (componentName) {
  var noDeprecationWarnings = useContext(FooterDeprecationContext);
  useDeprecationWarning({
    componentName: componentName,
    noDeprecationWarnings: noDeprecationWarnings
  });
};